import type { QueryClient } from "@tanstack/react-query";
import type { AttendantStatus, DocID } from "@/types";
import { scheduleCoalescedInvalidation } from "@/features/chat/realtime/coalescedInvalidation";

/** Conversas "abertas" do menu: Em atendimento + Aguardando (SA-1368). */
export const OPEN_CHAT_STATUSES: AttendantStatus[] = [
  "awaiting_human",
  "human",
];

export const isOpenChatStatus = (status?: string | null): boolean =>
  status === "awaiting_human" || status === "human";

/**
 * Key da contagem, DENTRO do prefixo `["chats"]`: toda invalidação das listas
 * (iniciar, encerrar, transferir, encerrar em massa) refaz a contagem junto.
 *
 * O objeto da key não tem `attendantFilters` de propósito: os patches de
 * socket (`updateCacheFor`, `removeChatFromLists`) leem os filtros dali para
 * inserir e tirar linhas, e uma lista sem filtro nunca recebe linha nem
 * desconta total. Quem mantém a contagem certa em tempo real é a invalidação
 * explícita (`invalidateOpenChatsCount`) quando um status muda.
 */
export const openChatsCountQueryKey = (sectorId?: DocID | null) =>
  ["chats", { sectorId: sectorId ?? null, openChatsCount: true }] as const;

/**
 * Refaz a contagem do menu (status de conversa mudou, conversa saiu de vista).
 * Agrupada (SA-1452): uma rajada de eventos vira uma request por janela.
 */
export const invalidateOpenChatsCount = (
  queryClient: QueryClient,
  sectorId?: DocID | null
): void =>
  scheduleCoalescedInvalidation(queryClient, openChatsCountQueryKey(sectorId), {
    exact: true,
  });
